<template>
  <div :class="classObj" class="app-wrapper">
    <navbar />
    <div class="app-wrapper-content">
      <sidebar class="sidebar-container" />
      <div class="main-container">
        <breadcrumb class="breadcrumb-container" />
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    Breadcrumb,
    AppMain,
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      };
    },
  },
  created() {
    // console.log('=====>') 
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "~@/styles/mixin.scss";
.app-wrapper {
  &-content{
    max-height: calc(100vh - 50px)
  }
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  .sidebar-container{
    height: 100%;
    /deep/ .el-scrollbar{
      height: 100%;
    }
    /deep/ .scrollbar-wrapper {
      overflow: auto;
    }
  }
  
}
</style>
